import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      CLOSE: "Lukk",
      IN_YOUR_SUBSCRIPTION: "I ditt abonnement",

      FORMAT_ADDON_COUNT: (addonCount: number) =>
        addonCount === 1
          ? `${addonCount} dagligvare`
          : `${addonCount} dagligvarer`,
      RECEIPT: "Kvittering",
      TOTAL: "Totalt",
    },

    dk: {
      CLOSE: "Luk",
      IN_YOUR_SUBSCRIPTION: "I dit abonnement",

      FORMAT_ADDON_COUNT: (addonCount: number) =>
        addonCount === 1
          ? `${addonCount} specialvare`
          : `${addonCount} specialvarer`,
      RECEIPT: "Kvittering",
      TOTAL: "I alt",
    },

    se: {
      CLOSE: "Stäng",
      IN_YOUR_SUBSCRIPTION: "I din prenumeration",

      FORMAT_ADDON_COUNT: (addonCount: number) => `${addonCount} livsmedel`,
      RECEIPT: "Kvitto",
      TOTAL: "Totalt",
    },
  } as const
)[language];
